/*jslint nomen: true, vars: true */
/*global interstate,able,uid,console,jQuery,Raphael,window */

(function (ist, $) {
	"use strict";
	var cjs = ist.cjs,
		_ = ist._;

	ist.CanvasAttachment = ist.register_attachment("group", {
			ready: function() {
			},
			destroy: function(silent) {
			},
			parameters: {
				children: function(contextual_object) {
				}
			},
			proto_props: {
			}
		});
}(interstate, jQuery));